import { useNavigate } from 'react-router-dom';
import { LogoSVG } from './ui/FormControls';

// ── SPLASH ───────────────────────────────────────────────────
export const SplashScreen = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0f172a 0%,#1e3a5f 50%,#0e7490 100%)", padding: "20px" }}>
      <div style={{ width: 112, height: 112, borderRadius: 24, background: "linear-gradient(145deg,#0ea5e9,#0369a1)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24, boxShadow: "0 0 40px rgba(14,165,233,0.5)" }}>
        <LogoSVG size={64} />
      </div>
      <h1 style={{ fontSize: 48, fontWeight: 900, color: "white", margin: "0 0 4px 0" }}>Ware<span style={{ color: "#38bdf8" }}>Hause</span><span style={{ color: "#22c55e" }}>Plan</span></h1>
      <p style={{ color: "#67e8f9", fontSize: 13, letterSpacing: "0.1em", marginBottom: 40 }}>OPERATIONAL CONTROL & VALIDATION</p>
           <button onClick={() => navigate("/app/login")} style={{ padding: "16px 40px", borderRadius: 16, background: "linear-gradient(90deg,#0ea5e9,#06b6d4)", color: "white", fontWeight: 700, fontSize: 18, border: "none", cursor: "pointer", boxShadow: "0 4px 30px rgba(14,165,233,0.5)" }}>
        Log in →
      </button>
      <p style={{ color: "#67e8f9", fontSize: 11, marginTop: 16, opacity: 0.6 }}>v1.8 · WareHausePlan © 2026</p>
    </div>
  );
};
